/**
 * Liefert einen Pfad inkl. (Vite) BASE_URL.
 * - Ergänzt ggf. fehlenden Slash am Ende der BASE_URL
 *
 * Beispiel:
 *   getAbsoluterPfad('images/foo.jpg')  ->  '/mein/base/url/images/foo.jpg'
 */
export function getAbsoluteSpaUrl(relPfad: string): string {
    return getAbsoluteUrl(import.meta.env.BASE_URL, relPfad);
}

function getAbsoluteUrl(baseUrl: string, relUrl: string): string {
    if (!baseUrl.endsWith('/')) {
        baseUrl += '/';
    }

    return baseUrl + relUrl;
}
